<template>
	<div class="ms-dropdown-item" @click="dropItemClick">
		<div
			v-if="iconDropdown"
			:class="[
				'mr-2',
				iconNew ? 'mi-new' : 'mi',
				isSize16 ? 'mi-16' : 'mi-24',
				iconDropdown ? iconDropdown : '',
			]"
		></div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: 'msDropdownItem',
	props: {
		iconDropdown: {
			default: null,
			type: String,
		},
		isSize16: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có dùng file icon new hay không
		 */
		iconNew: {
			default: false,
			type: Boolean,
		},
	},
	methods: {
		dropItemClick(event) {
			const me = this;
			me.$nextTick(() => {
				me.$emit('click', event);
				me.$parent.showDropdownMenu = false;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msDropdownItem.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msDropdownItem.scss';
}
</style>